import {React, useEffect} from 'react';
import AOS from 'aos';
import 'aos/dist/aos.css';
import property_legal from '../images/liaison/property_legal.png'
import property_valuvation from '../images/liaison/property_valuation.png'
import brokerage from '../images/liaison/Brokerage.png'
import arrow from '../images/liaison/Arrow.png'
import IT from '../images/Industries/micro-landing/IT_icon.png'
import logistics from '../images/Industries/micro-landing/logistics_icon.png'
import development from '../images/Industries/micro-landing/development_icon.png'
import commercial from '../images/Industries/micro-landing/commercial_icon.png'


function Other_Services () {
    let path = "Retail";

    useEffect(()=>{
        AOS.init({duration:1000});
      }, []);

    const other_services = [


        {
            src:property_legal,
            alt: "property legal service",
            heading:"Property Legal Services",
            content:"Lorem ipsum dolor sit amet consectetur. Scelerisque viverra suspendisse adipiscing in gravida. Ultricies consequa.",

        },
        {
            src:property_valuvation,
            alt: "Property Valuation",
            heading:"Property Valuation",
            content:"Lorem ipsum dolor sit amet consectetur. Scelerisque viverra suspendisse adipiscing in gravida. Ultricies consequa.",

        },
        {
            src:brokerage,
            alt: "Brokerage Services",
            heading:"Brokerage Services",
            content:"Lorem ipsum dolor sit amet consectetur. Scelerisque viverra suspendisse adipiscing in gravida. Ultricies consequa.",
        },
    ]

    const indsutries_served = [
        {
            image: IT,
            heading:"IT",
            image_class: "w-[85px] h-[86px]"
        },
        {
            image: logistics,
            heading: "Industrial Logistics",
            image_class: "w-[96px] h-[70px]"
        },
        {
            image: development,
            heading: "Development",
            image_class: "w-[102px] h-[80px]"
        },
        {
            image: commercial,
            heading: "Commercial",
            image_class: "w-[103px] h-[88px]"
        }
    ]

    return(
        <>

            {/* Other Services */}
            <div className= {path === "Retail" ? "hidden" : "max-w-6xl mx-auto font-[lato] my-14 sm:my-[121px]" } data-aos="fade-up">
                <h2 className="font-[merriweather] text-[52px] text-center leading-[43.50px] tracking-[-0.52px]"  data-aos="fade-up">Other Service</h2>

                <div className="max-w-[928px] mx-auto flex flex-wrap justify-between my-8 px-2 sm:mt-[77px]" data-aos="fade-up">
                    {
                    other_services.map((items) =>{
                        return(
                            <div className="w-[276px] h-[354px] bg-white border-2 border-[#E3E4E4] rounded-[8px] shadow-2xl shadow-[#E6E8E9] mt-10 mx-auto pt-[21px] px-[34px] transition ease-in-out duration-[650ms] hover:scale-[0.95] cursor-pointer min-[845px]:mt-0">
                                <img className="w-[85px] h-[85px] mx-auto sm:w-[91px] sm:h-[91px]" src={items.src} alt={items.alt} />
                                <div className="mt-[42px]">
                                    <h2 className="text-[19.50px] font-semibold leading-[21.375px] sm:text-[18px]">{items.heading}</h2>
                                    <p className="text-[15px] text-font-grey font-normal mt-[12px] sm:text-[14px] leading-[20px]">{items.content}</p>

                                    <img className="w-[37px] h-[37px] mx-auto mt-[22px]" src={arrow} alt="arrow"/>
                                </div>
                            </div>
                        )
                    })}
                </div>
                
            </div>


            {/* Industries Served (Other Services Industry Microlanding pages) */}

            <div className={path === "Retail" ? 'bg-card-grey py-28' : "hidden"}>
                <div className='max-w-7xl mx-auto'>
                    <h1 className='font-[merriweather] text-brown text-[45px] text-center leading-[43px] tracking-[0.45px]'>Industries Served</h1>

                    <div className='flex flex-col md:flex-row justify-center gap-y-10 gap-x-16 mt-20'>
                        {indsutries_served.map ((values) => {
                            return (
                                <div className='bg-white mx-auto shadow-sm p-8 rounded-lg w-[216px] h-[213px] hover:border-2 border-yellow '>
                                    <div className='flex flex-col items-center gap-y-9'>
                                        <img className={values.image_class} src={values.image} alt='Industries_Icon' />
                                        <p className='w-[123px] font-[Lato] text-black text-[17px] font-bold leading-[21px] tracking-[0.8px] text-center uppercase'>{values.heading}</p>
                                    </div>
                                </div>
                                    
                            )
                        })}
                    </div>
                
                </div>
            </div>

        </>
    );
}

export default Other_Services;